import { Component, OnInit } from '@angular/core';
import { AlertController, LoadingController, ModalController, NavController, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { UserProfile } from '../../models/user-profile.model';
import { RoleAccess } from '../../models/role-access.model';
import { UserData } from '../../providers/user-data';
import { Router } from '@angular/router';
import { CustomerListComponent } from '../../component/customer-list/customer-list.component';
import { UtilService } from '../../service/util.service';
import { RecalculateMemberPointService } from './recalculate-member-point.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-recalculate-member-point',
  templateUrl: './recalculate-member-point.page.html',
  styleUrls: ['./recalculate-member-point.page.scss'],
})
export class RecalculateMemberPointPage  implements OnInit {

  processed:number=0;
  totalMember:number=0;
  logs:any=[];
  progress = 0;
  processing = false;
  selectedCustomers:any[] = [];
  token:any;
  userProfile: UserProfile = new UserProfile();
  roleAccess = new RoleAccess();
  customerListDisplay:any='';
  customerIdDisplay:any='';
  activeMemberList : any[]=[];
  members: any[] = [];
  
  searchMember: any = '';
  customerList: any[] = [];
  selectedCustomer: any = null;
  showEmpty : boolean = false;
  showEmptyKey : boolean = false;
  isLoading : boolean  = false;


  constructor(
    private modalController : ModalController,
    private storage : Storage,
    private userData: UserData,
    private router: Router,
    private toastCtrl : ToastController,
    private navCtrl : NavController,
    private utilService : UtilService,
    private recalculateMemberPointService : RecalculateMemberPointService,
    private toastController: ToastController,
    private loadingController: LoadingController,
    private alertController:AlertController
  ){
  }
  
  ngOnInit() {}
  
  ionViewDidEnter() {
    Promise.all([
      this.storage.get("user_token"),
      this.storage.get("user_profile"),
      this.storage.get("user_menu_access"),
    ]).then(([token, profile, access]) => {
      if (token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.roleAccess = this.userData.checkAccess(
          this.router.url,
          access,
          this.userProfile
        );
        if (!this.roleAccess || this.roleAccess.view != "1") {
          this.toastCtrl
            .create({
              duration: 2000,
              message: "You Are Not Allowed to Access this Page",
            })
            .then((t) => t.present());
          this.navCtrl.navigateForward(["/"]);
        } else {
        }
      } else {
        this.toastCtrl
          .create({
            duration: 2000,
            message: "Silahkan login terlebih dahulu.",
          })
          .then((t) => t.present());
        this.navCtrl.navigateForward(["/login"]);
      }
    });
  }

  async searchCustomer() {

    this.showEmpty = false;
    this.showEmptyKey = false;

    if (
      !this.searchMember ||
      this.searchMember.trim().length < 1
    ) {

      this.customerList = [];
      this.showEmptyKey = true;

      return;
    }

    this.isLoading = true;
    this.customerList = [];

    let transactionDate = new Date();

    let convertDate =
      this.utilService.convertDate(transactionDate);

    let transDate =
      convertDate.years + '-' +
      convertDate.months + '-' +
      convertDate.dates;

    const option = {
      token: this.token,
      phoneNumber: this.searchMember,
      trans_date: transDate
    };

    this.recalculateMemberPointService
      .searchMember(option)
      .subscribe(

        (res: any) => {

          this.isLoading = false;

          if (
            res &&
            res.results &&
            res.results.customer &&
            res.results.customer.length > 0
          ) {

            this.customerList =
              res.results.customer;

          } else {

            this.customerList = [];
            this.showEmpty = true;

          }

        },

        (err) => {

          this.isLoading = false;

          this.customerList = [];
          this.showEmpty = true;

        }

      );
  }

selectCustomer(customer: any) {
  this.selectedCustomer = customer;
}

  async recalculatePoint(customer: any) {
    const alert = await this.alertController.create({
      header: 'Konfirmasi',
      message: 'Hitung ulang point member ini?',
      buttons: [
        {
          text: 'Batal',
          role: 'cancel'
        },
        {
          text: 'Ya',
          handler: async () => {
            const loading =
              await this.loadingController.create({
                message: 'Menghitung ulang point...'
              });
            await loading.present();
            const option = {
              token: this.token,
              customer_id: customer.id,
              username: this.userProfile.username
            };
            this.recalculateMemberPointService.recalculateMemberPoint(option)
              .subscribe(async (res: any) => {
                await loading.dismiss();
                var latestPoint = 0;
                var updatedAt = '';
                if ( res && res.results && res.results.customer ) {
                  customer.current_point =
                    res.results.customer.current_point;
                  customer.updated_at =
                    res.results.customer.updated_at;
                  latestPoint = res.results.customer.current_point || 0;
                  updatedAt = res.results.customer.updated_at || '-';
                }
                const successAlert =
                  await this.alertController.create({
                    header: 'Berhasil',
                    message: `
                      <p>Point berhasil dihitung ulang.</p>
                      <p>
                        <b>Customer :</b><br>
                        ${customer.customer_name}
                      </p>
                      <p>
                        <b>Point Terbaru :</b><br>
                        ${latestPoint}
                      </p>
                      <p>
                        <b>Last Update :</b><br>
                        ${updatedAt}
                      </p>
                    `,
                    buttons: ['OK']
                  });
                await successAlert.present();
            }, async () => {
              await loading.dismiss();
              const toast =
                await this.toastController.create({
                  message: 'Gagal hitung ulang point',
                  duration: 2000,
                  color: 'danger'
                });
              toast.present();
            });
          }
        }
      ]
    });
    await alert.present();
  }
}
